import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import {
    PublicClientApplication,
    AuthenticationResult,
    EventType,
    EventMessage,
} from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import { BrowserRouter as Router } from 'react-router-dom';
import { PaletteColorOptions, ThemeProvider, createTheme } from '@mui/material/styles';

// Bootstrap components
import 'bootstrap/dist/css/bootstrap.min.css';

const msalInstance = new PublicClientApplication(msalConfig);

// declare module '@mui/material/styles' {
//   interface CustomPalette {
//     green: PaletteColorOptions;
//   }
//   interface Palette extends CustomPalette {}
//   interface PaletteOptions extends CustomPalette {}
// }
  
// declare module '@mui/material/Button' {
//   interface ButtonPropsColorOverrides {
//     green: true;
//   }
// }
  

// const { palette } = createTheme();
// const { augmentColor } = palette;
// const createColor = (mainColor: any) => augmentColor({ color: { main: mainColor } });


const darkTheme = createTheme({
    palette: {
        mode: 'dark',
        // green: createColor('#007738'),
    },
});

msalInstance.initialize().then(() => {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
        }
    });

    msalInstance
        .handleRedirectPromise()
        .then((response) => {
            if (response !== null) {
                msalInstance.setActiveAccount(response.account);
            }
        })
        .catch((error) => {
            console.error('MSAL redirect error:', error);
        })
        .finally(() => {
            const root = ReactDOM.createRoot(
                document.getElementById('root') as HTMLElement
            );
            root.render(
                <MsalProvider instance={msalInstance}>
                    <Router>
                        <ThemeProvider theme={darkTheme}>
                            <App />
                        </ThemeProvider>
                    </Router>
                </MsalProvider>
            );
        });
});

/*const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <MsalProvider instance={msalInstance}>
          <App />
      </MsalProvider>
  </React.StrictMode>
);*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
